import { InvoicingTab } from './invoicingTab';

require('./invoicingTab.scss');

export const myInvoicingTabComponent = {
  template: require('./invoicingTab.html'),
  controllerAs: 'ctrl',
  controller: InvoicingTab,
};